import { removeBooking, setBookingStatus } from '../../services/bookings';

export default function EnquiryActions({ booking, links, run, compact = false }) {
  const b = booking;
  return (
    <div className="enq-actions">
      {links.whatsapp && <a className="enq-btn enq-wa" href={links.whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp</a>}
      {links.call && <a className="enq-btn" href={links.call}>Call</a>}
      {links.email && <a className="enq-btn" href={links.email}>Email</a>}
      {!compact && <span className="enq-spacer" />}
      {b.status !== 'confirmed' && <button type="button" className="enq-btn enq-ok" onClick={() => run(() => setBookingStatus(b.id, 'confirmed'))}>Confirm</button>}
      {b.status !== 'cancelled' && <button type="button" className="enq-btn" onClick={() => run(() => setBookingStatus(b.id, 'cancelled'))}>Cancel</button>}
      {b.status !== 'pending' && <button type="button" className="enq-btn" onClick={() => run(() => setBookingStatus(b.id, 'pending'))}>Mark pending</button>}
      <button type="button" className="enq-btn enq-danger" onClick={() => window.confirm('Delete this booking?') && run(() => removeBooking(b.id))}>Delete</button>
    </div>
  );
}